// LinkedLegsInfo.tsx
import { Divider, makeStyles } from '@material-ui/core';
import { useStores } from 'doc-mate-store/lib/hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import LinkIcon from './LinkIcon.svg';

type LegItem = number | { id: number; dmId: string };

type Props = {
  isLinked: boolean;
  legInfoList: LegItem[];
};

const LinkedLegsInfo: React.FC<Props> = ({ isLinked, legInfoList }) => {
  const classes = useStyles();
  const { rootStore } = useStores();

  return (
    <div className={classes.linkedLegInfo}>
      <div className="linked-container">
        <img src={LinkIcon} alt="Link" />
        <span className="linked-text">
          {isLinked ? ' Linked To' : ' Manifest Legs'}
        </span>
      </div>

      {legInfoList.map(item => {
        const legId = typeof item === 'object' ? item.id : item;
        const dmId =
          typeof item === 'object' && item.dmId
            ? item.dmId
            : rootStore.loadTableRows.get(`${legId}`)?.dmId;

        if (dmId) {
          return (
            <div className="name-container" key={legId}>
              DM-ID <span className="name-value">{dmId}</span>
            </div>
          );
        }
        return null;
      })}

      <Divider />

      <div className="note-container">
        {isLinked ? (
          <>
            Note: Linked DM-IDs will be
            <br />
            assigned to the same driver
          </>
        ) : (
          <>
            Note: Non-linked DM-IDs can be
            <br />
            assigned to different drivers
          </>
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  linkedLegInfo: {
    width: 250,
    backgroundColor: 'white',
    position: 'absolute',
    zIndex: 3,
    marginTop: 20,
    borderRadius: 5,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',

    '& .linked-container': {
      display: 'block',
      width: '100%',
      textAlign: 'center',
      padding: '10px 30px',

      '& .linked-text': {
        fontSize: 16,
        color: '#4f4f4f',
        fontWeight: 600,
      },
    },
    '& .name-container': {
      width: '100%',
      display: 'block',
      textAlign: 'center',
      fontSize: 16,
      padding: '8px 30px',
      color: '#4f4f4f',
      '& .name-value': {
        fontWeight: 700,
      },
    },
    '& .note-container': {
      maxWidth: '100%',
      display: 'block',
      textAlign: 'center',
      fontSize: 13,
      color: '#155878',
      padding: '12px 20px',
      fontWeight: 500,
      lineHeight: 1.4,
    },
  },
}));

export default observer(LinkedLegsInfo);
